import Vue from 'vue';
import Router from 'vue-router';
import Index from '../view/index';
import Home from '../view/home';
import ProductList from "../view/productList";
import ProductDetails from "../view/productDetails";
import Login from "../view/Auth/login";
import Cart from "../view/cart";
import About from "../view/about";
import Contact from "../view/contact";
import Terms from "../view/terms";
import Privacy from "../view/privacy";
import Register from "../view/Auth/register";
import Account from "../view/account";
import Addresses from "../view/addresses";
import Purchase from "../view/purchase";
import Collections from "../view/collections";
import Category2 from "../view/category2List";
import ReturnsAndRefunds from "../view/returnsAndRefunds";
import Confirmation from "../view/confirmation";
import Search from '../view/search.vue';
import Order from '../view/order.vue';
import store from '../store';
import DriverApplication from '../view/driverApplication.vue';
import Profile from '../view/Profile';
import NotFound from "../view/404";
Vue.use(Router);

async function validateToken (token) {
  //axios request to valida token
  return true
}
// const guard = async (to, from, next) => {
//   try {
//     const token = localStorage.getItem('token');
//     if(token && validateToken(token)) {
//       next('/');
//     } else {
//       next();
//     }
//   } catch(err) {
//     console.log('err find in guard', err);
//   }
// };

const routeToAccount = (to, from, next) => {
  // store.dispatch('addresses/fetchAddresses');
  // store.dispatch('addresses/fetchDefaultAddress');
  store.dispatch('orders/fetchOrderByTimeFrame', 3);
  // store.dispatch('auth/fetchCustomerInformation');
  next();
}

const router =  new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      children: [
        {
          path: '/',
          name: 'home',
          component: Home,
        }, {
          path: '/home/:inviteCode',
          name: 'home',
          component: Home,
          props:true,
        }, 
        // {
        //   path: '/wechatinvite',
        //   name: 'wechatInvite',
        //   component: WechatInvite,
        // }, 
        {
          path: '/collections/:group',
          name: 'productList',
          component: ProductList,
          props:true,
        }, {
          path: '/productDetails',
          name: 'productDetails',
          component: ProductDetails,
        },{
          path: '/login',
          name: 'login',
          // beforeEnter: guard,
          component: Login,
        }, {
          path: '/cart',
          name: 'cart',
          component: Cart,
        }, {
          path: '/about-us',
          name: 'about',
          component: About,
        }, {
          path: '/contact-us',
          name: 'contact',
          component: Contact,
        }, {
          path: '/returns-and-refunds',
          name: 'returns-and-refunds',
          component: ReturnsAndRefunds,
        }, {
          path: '/terms-of-service',
          name: 'terms',
          component: Terms,
        }, {
          path: '/privacy',
          name: 'privacy',
          component: Privacy,
        }, {
          path: '/register/:inviteCode',
          name: 'register',
          component: Register,
          props:true,
        }, {
          path: '/register',
          name: 'register',
          component: Register,
        }, {
          path: '/account',
          name: 'account',
          component: Profile,
          beforeEnter: routeToAccount,
        }, {
          path: '/addresses',
          name: 'addresses',
          component: Addresses,
        },{
          path: '/purchase',
          name: 'purchase',
          component: Purchase,
        },
        {
          path: '/confirmation',
          name: 'confirmation',
          component: Confirmation,
        },
        {
          path: '/order/:order_id',
          name: 'order',
          component: Order,
        },
        {
          path: '/collections',
          name: 'collections',
          component: Collections,
        },{
          path: '/search',
          name: 'search',
          component: Search,
        },{
          path: '/category2/:cat2',
          name: 'category2',
          component: Category2,
          props: true,
        },{
          path: '/driverapplication',
          name: 'driverapplication',
          component: DriverApplication,
          props: true,
        },
        { path: '*', component: NotFound }
      ]
    }
  ],
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } 
      return { x: 0, y: 0 }   
  },
})

router.beforeEach((to, from, next) => {
  // store.dispatch('fetchAccessToken');
  const token = localStorage.getItem('token');
  if (to.fullPath === '/account'||to.fullPath.includes('/order')) {
    if (!token) {
      next('/login');
    }
  }
  if (to.fullPath === '/login') {
    if (token) {
      next('/account');
    }
  }
  next();
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js